<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex style="max-width: 500px">
        <v-card v-if="status === 'success'" flat>
          <v-alert type="info" :value="status === 'success'"
            >Registration abgeschlossen</v-alert
          >

          <v-card-text class="text-xs-center">{{
            $t(
              "Thank you for signing up. You will receive a verification e-mail."
            )
          }}</v-card-text>
        </v-card>
        <v-card v-else flat>
          <v-card-text>
            <v-card>
              <v-card-title class="title">{{ $t("Sign Up") }}</v-card-title>
              <v-card-text>
                <v-alert type="error" :value="status === 'failure'"
                  >Something went wrong</v-alert
                >
                <v-alert type="info" :value="status === 'success'"
                  >Registration abgeschlossen</v-alert
                >
              </v-card-text>
              <v-card-text>
                <v-form v-model="valid" style="width: 100%; height: 100%">
                  <v-select
                    :rules="requiredRule"
                    required
                    :items="activeSections"
                    item-text="name"
                    item-value="_id"
                    label="Sektion"
                    v-model="section"
                  >
                  </v-select>
                  <v-text-field
                    autofocus
                    :rules="requiredRule"
                    required
                    v-model="nickname"
                    label="Angezeigter Kurzname innerhalb des Vereins"
                  ></v-text-field>
                  <v-text-field
                    :rules="requiredRule"
                    required
                    v-model="firstname"
                    label="Vorname"
                  ></v-text-field>
                  <v-text-field
                    :rules="requiredRule"
                    required
                    v-model="lastname"
                    label="Nachname"
                  ></v-text-field>
                  <v-text-field
                    :rules="requiredRule"
                    type="date"
                    required
                    v-model="birthday"
                    label="Geburtstag"
                  ></v-text-field>
                  <v-text-field
                    :rules="requiredRule"
                    required
                    v-model="street"
                    label="Strasse/Hausnummer"
                  ></v-text-field>
                  <v-text-field
                    :rules="requiredRule"
                    type="number"
                    required
                    v-model="postcode"
                    label="Postleitzahl"
                  ></v-text-field>
                  <v-text-field
                    :rules="requiredRule"
                    required
                    v-model="town"
                    label="Ort"
                  ></v-text-field>
                  <v-text-field
                    :rules="requiredRule"
                    required
                    v-model="phone"
                    label="Telefon Nr."
                  ></v-text-field>
                  <v-text-field
                    :rules="emailRule"
                    required
                    v-model="email"
                    label="E-Mail"
                  ></v-text-field>
                  <v-text-field
                    type="password"
                    :rules="requiredRule"
                    required
                    v-model="password"
                    label="Passwort"
                  ></v-text-field>
                  <v-text-field
                    type="password"
                    :rules="passwortCheckRule"
                    required
                    v-model="password_check"
                    label="Passwort wiederholen"
                    @keydown.enter="sendPassword()"
                  ></v-text-field>
                  <v-checkbox v-model="dsgvo" :rules="requiredRule" required>
                    <template v-slot:label>
                      <div>
                        Ich stimme bis auf Widerruf der
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <a
                              target="_blank"
                              href="https://www.atuskalsdorf.at/app/download/8245182615/ATUS+Datenschutzerklärung_1.0.pdf"
                              @click.stop
                              v-on="on"
                            >
                              Datenschutzerklärung
                            </a>
                          </template>
                          Datenschutzerklärung in einem neuen Fenster öffnen
                        </v-tooltip>
                        zu.
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-model="e_invoice">
                    <template v-slot:label>
                      <div>
                        Ich stimme der elektronischen Rechnungslegung zu um dem
                        Verein Aufwand zu ersparen.
                      </div>
                    </template>
                  </v-checkbox>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>

              <vue-recaptcha
                ref="recaptcha"
                @verify="onVerify"
                @expired="onExpired"
                :sitekey="recaptchaWebSite"
                :loadRecaptchaScript="true"
              >
              </vue-recaptcha>
              <v-btn small @click="resetRecaptcha"> Reset ReCAPTCHA </v-btn>
              <v-alert
                type="error"
                v-if="statusSignUp"
                :value="status === 'failure'"
                >{{ statusSignUp.message }}</v-alert
              >
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  outlined
                  rounded
                  :disabled="!valid || !verifiedReCaptcha"
                  color="primary"
                  @click="
                    signUp({
                      email,
                      password,
                      nickname,
                      firstname,
                      lastname,
                      birthday,
                      street,
                      postcode,
                      town,
                      phone,
                      dsgvo,
                      e_invoice,
                      member_of,
                    })
                  "
                  >{{ $t("Sign Up") }}</v-btn
                >
              </v-card-actions>
              <v-divider></v-divider>
              <p align="center">
                <br />
                <router-link :to="{ name: 'login' }">{{
                  $t("Back to Login")
                }}</router-link>
                <br />
                <br />
              </p>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { requiredRule, emailRule } from "../utils/rules";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "SignUp",
  components: { VueRecaptcha },
  data() {
    return {
      passwortCheckRule: [
        (v) => (v && v == this.password) || "Passwörter stimmen nicht überein",
      ],
      nickname: "",
      firstname: "",
      lastname: "",
      birthday: null,
      street: "",
      postcode: null,
      town: "",
      phone: "",
      password: "",
      password_check: "",
      email: "",
      valid: false,
      dsgvo: false,
      e_invoice: false,

      requiredRule,
      emailRule,
      verifiedReCaptcha: false,
      section: "",
      // atus.makerspace.at
      recaptchaWebSite: "6LfdN9cZAAAAAGds0i_AXB18tnI7Llfg0xsfiZWr",

      //LocalHost
      //recaptchaWebSite: "6LfTOdcZAAAAAGGGhb4xj13gN6SAibUjxz8_7m1x",
      //recaptchaWebSite: "6LfCOtcZAAAAACXjcfn8U70F_MPCvtluKnl6PMm4",
    };
  },
  created() {
    if (process.env.NODE_ENV === "production") {
      this.recaptchaWebSite = "6LfdN9cZAAAAAGds0i_AXB18tnI7Llfg0xsfiZWr";
    } else {
      this.recaptchaWebSite = "6LfTOdcZAAAAAGGGhb4xj13gN6SAibUjxz8_7m1x";
    }
  },
  async mounted() {
    await this.getSections({});
    this.section = this.Sections[0]._id;
  },
  methods: {
    ...mapActions("user", ["signUp"]),
    ...mapActions("section", ["getSections"]),
    onSubmit: function () {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function (response) {
      //console.log("Verify: " + response);
      this.verifiedReCaptcha = true;
    },
    onExpired: function () {
      //console.log("Expired");
      this.verifiedReCaptcha = false;
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
      this.verifiedReCaptcha = false;
    },
  },
  computed: {
    ...mapState({
      statusSignUp: ({ user }) => user.statusSignUp,
      status: ({ user }) => user.status,
      Sections: ({ section }) => section.Sections,
    }),
    member_of() {
      const member_of = [{ section_id: this.section }];
      return member_of;
    },
    activeSections() {
      return _.filter(this.Sections, { active: true });
    },
  },
};
</script>

<style scoped>
</style>
